import React, {Component} from 'react'
import NavBar from '../components/NavBar'

class App extends Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    //Uncomment if you want to do a edirect
    //this.props.router.push('/fireadmin/clubs+skopje+items') //Path where you want user to be redirected initialy
  }
  render() {
    return (
      <div className="content">
        <NavBar></NavBar>

        <div className="content">
          <div className="container-fluid">
            <h2>Dashboard</h2>
            <br />
            <p>Welkom bij Sjaloom Connect Admin.<br/>
            Hier kunt u mededelingen toevoegen, bewerken en/of verwijderen.</p>

            <p>Tevens kan vanaf hier ook push berichten verstuurd worden naar degene die zicht ervoor hebben aangemeld.</p>
          </div>
        </div>
      </div>
    )
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js